"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Desio certificazione contatti
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LottoCsvDtoToJSON = exports.LottoCsvDtoFromJSONTyped = exports.LottoCsvDtoFromJSON = void 0;
const runtime_1 = require("../runtime");
function LottoCsvDtoFromJSON(json) {
    return LottoCsvDtoFromJSONTyped(json, false);
}
exports.LottoCsvDtoFromJSON = LottoCsvDtoFromJSON;
function LottoCsvDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'dataInizioCampagna': !runtime_1.exists(json, 'dataInizioCampagna') ? undefined : (new Date(json['dataInizioCampagna'])),
        'dataFineCampagna': !runtime_1.exists(json, 'dataFineCampagna') ? undefined : (new Date(json['dataFineCampagna'])),
        'name': !runtime_1.exists(json, 'name') ? undefined : json['name'],
        'file': !runtime_1.exists(json, 'file') ? undefined : json['file'],
    };
}
exports.LottoCsvDtoFromJSONTyped = LottoCsvDtoFromJSONTyped;
function LottoCsvDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'dataInizioCampagna': value.dataInizioCampagna === undefined ? undefined : (value.dataInizioCampagna.toISOString()),
        'dataFineCampagna': value.dataFineCampagna === undefined ? undefined : (value.dataFineCampagna.toISOString()),
        'name': value.name,
        'file': value.file,
    };
}
exports.LottoCsvDtoToJSON = LottoCsvDtoToJSON;
